<!--suppress ALL -->
<template>
	<v-select
		:items="options"
		:required="required"
		v-bind="$attrs"
		v-model="model"
		:disabled="disable"
		item-value="id"
		item-text="name"
		:label="$t('pages.projectForm.branch')"
		:clearable="clearable && !required"></v-select>
</template>
<script>
	import BranchModule from "src/store/modules/Branch.module";
	import SelectMixin from "src/mixins/SelectMixin";

	export default {
		name: "branches-select",
		props: {
			value: {default: null},
			disable: {default: false},
			clearable: {default: true},
			required: {default: false}
		},
		components: {},
		mixins: [new SelectMixin(BranchModule, "branches")],
		methods: {
			setModel() {
			},
		},
		watch: {
			options: {
				immediate: true,
				handler() {
					if (this.options.length == 1) {
						this.model = this.options[0].id;
						setTimeout(() => {
							this.model = this.options[0].id;
						}, 1000);
					}
				}
			}
		}
	};
</script>
